// filepath: c:\Users\minmi\OneDrive\Desktop\Emergent-AI-Watch-ID-main\frontend\src\components\Breadcrumbs.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Breadcrumbs = ({ breadcrumbs }) => {
  const { t } = useTranslation(); // Ensure t is defined

  if (!breadcrumbs || breadcrumbs.length === 0) {
    return null;
  }

  return (
    <nav aria-label="breadcrumb" className="bg-gray-100 p-3 rounded-md shadow-sm mb-4 sticky top-[72px] z-40">
      {/* Adjusted sticky top value assuming header height is approx 72px */}
      <ol className="list-none p-0 inline-flex space-x-2">
        {breadcrumbs.map((crumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          // Use t() for translating crumb.name if it's a translation key
          const displayName = t(crumb.name) || crumb.name;
          return (
            <li key={index} className="flex items-center">
              {index > 0 && <span className="mx-2 text-gray-500">/</span>}
              {isLast ? (
                <span className="text-gray-700 font-semibold">{displayName}</span>
              ) : (
                <Link to={crumb.path} className="text-blue-600 hover:text-blue-800 hover:underline">
                  {displayName}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
